import { render, staticRenderFns } from "./FinishWizard.vue?vue&type=template&id=6b954500"
import script from "./FinishWizard.vue?vue&type=script&lang=js"
export * from "./FinishWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports